import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Input, Button } from 'htlib-copy';

export default function Home() {
  const { push } = useHistory();
  const [missionId, setMissionId] = useState('');

  return (
    <div className="App__form">
      <Input
        label="Please enter a mission id"
        placeholder="Mission id"
        value={missionId}
        onChange={({ target: { value } }) => {
          setMissionId(value);
        }}
      />
      <div className="App__btnWrapper">
        <Button
          type="primary"
          onClick={() => {
            push(`/missions/${missionId}`);
          }}
        >
          Go
        </Button>
      </div>
    </div>
  );
}
